// components/ResumenSucursal.jsx
import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  useTheme
} from '@mui/material';
import {
  Storefront as StoreIcon,
} from '@mui/icons-material';
import Navbar from '../../Navbar';
import FiltrosResumen from './components/FiltrosResumen';
import CardPagosMercadoPago from './components/CardPagosMercadoPago';
import CardComprobantes from './components/CardComprobantes';
import CardPagos from './components/pagos/CardPagos';
import { useFechas } from '../pedidosEnvasado/context/FechaContext';
import CardProductos from './components/kilos/CardProductos';
import CardRendiciones from './components/rendiciones/CardRendiciones';
import CardCambios from './components/cambios/CardCambios';
import CardPromoSena from './components/promosena/CardPromoSena';

function ResumenSucursal() {
  const theme = useTheme();
  const { desde, hasta } = useFechas();
  const [loading, setLoading] = useState(false);
  const [filtrosActivos, setFiltrosActivos] = useState(null);
  const [triggerConciliacion, setTriggerConciliacion] = useState(0);
  const [triggerPagos, setTriggerPagos] = useState(0);
  const [triggerProductos, setTriggerProductos] = useState(0); 
  const [triggerComprobantes, setTriggerComprobantes] = useState(0);
  const [triggerRendiciones, setTriggerRendiciones] = useState(0);
  const [triggerCambios, setTriggerCambios] = useState(0);
  const [triggerPromoSena, setTriggerPromoSena] = useState(0);

  const handleFilter = async (filtros) => {
    setLoading(true);
    try {
      // console.log('Filtrando con:', filtros);
      
      const sucursalData = filtros.sucursal || {};
      const filtrosProcesados = {
        sucursalId: sucursalData.id,
        mpStoreId: sucursalData.mp_store_id,
        sucursalNombre: sucursalData.nombre,
        desde: filtros.desde,
        hasta: filtros.hasta,
        sucursal: sucursalData
      };
      
      // console.log('Filtros procesados:', filtrosProcesados);
      setFiltrosActivos(filtrosProcesados);
      setTriggerConciliacion(prev => prev + 1);
      setTriggerPagos(prev => prev + 1);
      setTriggerProductos(prev => prev + 1); 
      setTriggerComprobantes(prev => prev + 1);
      setTriggerRendiciones(prev => prev + 1);
      setTriggerCambios(prev => prev + 1);
      setTriggerPromoSena(prev => prev + 1);

      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (error) {
      console.error('Error al filtrar:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilters = () => {
    setFiltrosActivos(null);
    setTriggerConciliacion(0);
    setTriggerPagos(0);
    setTriggerProductos(0);
    setTriggerComprobantes(0);
    setTriggerRendiciones(0);
    setTriggerCambios(0);
    setTriggerPromoSena(0);
    // console.log('Filtros limpiados');
  };

  return (
    <>
      <Navbar />
      
      <FiltrosResumen 
        onFilter={handleFilter}
        onClear={handleClearFilters}
      />

      <Container maxWidth="xl" sx={{ mt: 2.5, mb: 10 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.5 }}>
          <Typography variant="h5" component="h1" sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            fontWeight: 500,
            color: '#1a1a1a',
            fontSize: '1.3rem'
          }}>
            <StoreIcon sx={{ mr: 1.5, color: '#424242', fontSize: 28 }} />
            Resumen por Sucursal
          </Typography>
          
          {filtrosActivos && (
            <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.75rem' }}>
              {filtrosActivos.sucursalNombre && `Sucursal: ${filtrosActivos.sucursalNombre} · `}
              {filtrosActivos.mpStoreId && `MP Store: ${filtrosActivos.mpStoreId} · `}
              Actualizado: {new Date().toLocaleString()}
            </Typography>
          )}
        </Box>

        <Grid container spacing={3} mb={10}>
          <Grid item xs={12} md={6}>
            <CardPagosMercadoPago 
              key={`conciliacion-${triggerConciliacion}`}
              sucursalId={filtrosActivos?.sucursalId}
              sucursalNombre={filtrosActivos?.sucursalNombre}
              mpStoreId={filtrosActivos?.mpStoreId}
              desde={filtrosActivos?.desde}
              hasta={filtrosActivos?.hasta}
              loading={loading}
              triggerRecarga={triggerConciliacion}
              sucursal={filtrosActivos?.sucursal}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <CardRendiciones 
              key={`rendiciones-${triggerRendiciones}`}
              sucursal={filtrosActivos?.sucursal}
              desde={filtrosActivos?.desde}
              hasta={filtrosActivos?.hasta}
              loading={loading}
              triggerRecarga={triggerRendiciones}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <CardPagos 
              key={`pagos-${triggerPagos}`}
              sucursal={filtrosActivos?.sucursal}
              desde={filtrosActivos?.desde}
              hasta={filtrosActivos?.hasta}
              loading={loading}
              triggerRecarga={triggerPagos}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <CardCambios 
              key={`cambios-${triggerCambios}`}
              sucursal={filtrosActivos?.sucursal}
              desde={filtrosActivos?.desde}
              hasta={filtrosActivos?.hasta}
              loading={loading}
              triggerRecarga={triggerCambios}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <CardProductos 
              key={`productos-${triggerProductos}`}
              sucursal={filtrosActivos?.sucursal}
              desde={filtrosActivos?.desde}
              hasta={filtrosActivos?.hasta}
              loading={loading}
              triggerRecarga={triggerProductos}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <CardPromoSena 
              key={`promosena-${triggerPromoSena}`}
              sucursal={filtrosActivos?.sucursal}
              desde={filtrosActivos?.desde}
              hasta={filtrosActivos?.hasta}
              loading={loading}
              triggerRecarga={triggerPromoSena}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <CardComprobantes 
              key={`comprobantes-${triggerComprobantes}`}
              sucursal={filtrosActivos?.sucursal}
              desde={filtrosActivos?.desde}
              hasta={filtrosActivos?.hasta}
              loading={loading}
              triggerRecarga={triggerComprobantes}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default ResumenSucursal;